import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import search from "../../../assets/svg/search.svg";
import ProductImage from "../../../assets/images/our-product.png";
import { GetAllOrder } from "../../../Services/OrderService";
import { getImageUrl, handleImageError } from "../../../utils/imageUtils";

const NotShipped = () => {
  const [orders, setOrders] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  // ✅ Fetch orders
  const fetchOrders = async (term = "") => {
    const userId = localStorage.getItem("userId");
    if (!userId) {
      console.error("User ID not found");
      setLoading(false);
      return;
    }
    try {
      const params = { userId: parseInt(userId) };
      if (term) params.filter = term;
      const response = await GetAllOrder(params);
      setOrders(response?.data?.orders || []);
    } catch (error) {
      console.error("Error fetching orders:", error);
      setOrders([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchOrders();
  }, []);

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      fetchOrders(searchTerm);
    }, 400);
    return () => clearTimeout(delayDebounce);
  }, [searchTerm]);

  const handleOrderTracking = async (orderGuid) => {
    navigate("/order-tracking", { state: { orderGuid } });
  };

  return (
    <div className="main-content">
      <div className="d-flex align-items-center justify-content-between mb_28 order-content-box">
        <div className="d-flex align-items-center justify-content-between gap-2">
          <h2 className="mb-0 fw_600 fs_24 lh-1">Not Shipped Orders</h2>
          <div className="drop-down-content d-md-none">
            <select className="form-select select-transparent">
              <option selected>Past 3 Months</option>
              <option>2025</option>
              <option>2024</option>
            </select>
          </div>
        </div>

        <div className="form-input search-field">
          <input
            type="text"
            className="form-control"
            placeholder="Search Your Order"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <img src={search} alt="Search" className="search-icon" />
        </div>
      </div>

      {loading ? (
        <div className="text-center py_50">
          <h5 className="fs_18 fw_400 text-muted">Fetching your orders...</h5>
        </div>
      ) : orders?.length === 0 ? (
        <div className="text-center py_50">
          <h5 className="fs_20 fw_500 text-muted">No Orders Found</h5>
        </div>
      ) : (
        <div className="order-list-box" style={{overflowY:"auto",maxHeight:"400px"}}>
          {orders.map((order) => (
            <div key={order.orderId} className="order-card">
              <p className="fs_18 fw_400 lh-1 text-color mb-3"><b>Order ID:</b> #{order.orderGuid}</p>
              <hr className="mt-0 mb-4" />
              <div className="order-grid-list">
              {order.products.map((product) => (
                <div
                  key={product.productId}
                  className="cart-grid d-flex align-items-center justify-content-between gap-2"
                >
                  <div className="d-flex align-items-start">
                    <div className="img-wrapper">
                      <img
                        className="img-fluid"
                        src={getImageUrl(product.image, ProductImage)}
                        onError={(e) => handleImageError(e, ProductImage)}
                        alt="cart product"
                      />
                    </div>
                    <div>
                      <div className="mb_10">
                        <h6 className="fs_24 fw_700 text-color mb-0">
                          {product.productName} {product.weight > 0 && `(${product.weight}KG)`}
                        </h6>
                      </div>
                      <div className="tag-list d-flex align-items-center">
                        {product.attributes.subProducts.map((subProduct) => (
                          <div key={subProduct.id} className="tag py_10 px_10 fs_12 text-color">
                            {subProduct.name} {subProduct.weight}
                          </div>
                        ))}
                        {product.attributes.attributes.map((attr) => (
                          <div key={attr.id} className="tag py_10 px_10 fs_12 text-color">
                            {attr.value}
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                  <div>
                    <button onClick={(e) => handleOrderTracking(order.orderGuid)} className="button btn-solid text-uppercase">Track Order</button>
                  </div>
                </div>
              ))}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default NotShipped;